/**
 * CSRF 토큰 유틸리티
 *
 * GET /api/csrf-token 으로 토큰을 1회 조회 후 캐싱.
 * api.ts의 fetch 래퍼가 변경 요청(POST/PUT/DELETE/PATCH) 시 자동 주입.
 */

let cachedToken: string | null = null;
let fetchPromise: Promise<string> | null = null;

const CSRF_HEADER = "X-CSRF-Token";

/** 서버에서 CSRF 토큰을 가져온다 (캐싱됨) */
export async function getCsrfToken(): Promise<string> {
  if (cachedToken) return cachedToken;

  // 동시 호출 시 중복 요청 방지
  if (fetchPromise) return fetchPromise;

  fetchPromise = (async () => {
    try {
      const res = await fetch("/api/csrf-token", {
        credentials: "same-origin",
      });
      if (res.ok) {
        const data = await res.json();
        cachedToken = (data as { csrfToken?: string }).csrfToken || "";
        return cachedToken;
      }
      return "";
    } catch {
      return "";
    } finally {
      fetchPromise = null;
    }
  })();

  return fetchPromise;
}

/** 403 CSRF 에러 시 토큰 갱신용 */
export function invalidateCsrfToken(): void {
  cachedToken = null;
}

export { CSRF_HEADER };
